import { Message } from "./Interface";
import { PostMessageConnectorBase } from "./PostMessageConnectorBase";
import { InboundPartnr, PartNrMessage, AssignmentMessage, Assignment, InternalAlternate } from "../types/CommonTypes";
import { validatePartnrPayload } from "../utils/validatePartnrPayload";

type InternalPartnr = {
    partNumber: string;
    bmId?: string;
    stMaterialId?: string;
    bmName?: string;
    stName?: string;
    isAssembly?: string;
    stDensity?: string;
    bmDensity?: string;
    coverage?: string;
    thickness?: string;
    alternates?: InternalAlternate[];
};

export class AbbWindchillConnector extends PostMessageConnectorBase {

    protected readonly name = "AbbWindchillConnector";
    protected readonly protocolVersion = 1;
    protected readonly advertisedMessageTypes = [
        { type: PartNrMessage.type, version: PartNrMessage.version },
        { type: AssignmentMessage.type, version: AssignmentMessage.version },
    ] as const;

    protected sendDomainMessage(message: Message): void {
        if (message instanceof AssignmentMessage) {
            const payload: any = { ...message.assignment };
            if (message.alternates) {
                payload.alternates = message.alternates.map(a => ({
                    partNr: a.partNr,
                    bmId: a.materialId,
                    bmName: a.materialName,
                    abbId: a.abbId ?? null,
                    bmDensity: a.materialDensity ?? null,
                    conditionType: a.conditionType ?? null,
                    conditionCode: a.condition?.code ?? null,
                    condition: a.condition ?? null,
                }));
            }
            this.postToTarget(payload);
        } else {
            super.sendDomainMessage(message);
        }
    }

    protected handleIncomingData(data: unknown): void {
        this.handlePartnrMessage(data);
    }

    private handlePartnrMessage(data: unknown){
        const parts = validatePartnrPayload<InternalPartnr>(data, this.name);
        if (parts.length === 0) {
            console.debug(`[${this.name}]: No valid part entries found in payload, ignoring.`);
            return;
        }
        const converted: InboundPartnr[] = parts.map(p => ({
            partnr: p.partNumber,
            bmId: p.bmId || undefined,
            stMaterialId: p.stMaterialId || undefined,
            bmName: p.bmName,
            stName: p.stName,
            isAssembly: `${p.isAssembly}`.toLowerCase() === "true",
            stDensity: p.stDensity,
            bmDensity: p.bmDensity,
            coverage: p.coverage,
            thickness: p.thickness,
            alternates: Array.isArray(p.alternates)
                ? p.alternates
                    .filter(a => a.bmId)
                    .map(a => ({
                        bmId: a.bmId!,
                        bmName: a.bmName,
                        bmDensity: a.bmDensity,
                        abbId: a.abbId ?? null,
                        conditionType: (a.conditionType as 'color' | 'dimension' | null) ?? null,
                        condition: a.condition ?? null,
                    }))
                : undefined,
        }));
        this.notifyListeners(this.envelope(new PartNrMessage(converted)));
    }
}